/**
 * Product categories for the /medical-laboratory catalog.
 * Order matches the user's brief; slugs are canonical.
 */
export const PRODUCT_CATEGORIES = [
  { slug: "analytical-laboratory-instruments", name: "Analytical Laboratory Instruments" },
];

export const CATEGORY_NAME_BY_SLUG = Object.fromEntries(
  PRODUCT_CATEGORIES.map((c) => [c.slug, c.name])
);

export function categoryName(slug) {
  return CATEGORY_NAME_BY_SLUG[slug] || slug;
}
